import { useTranslation } from "react-i18next"
import { formatTimestamp } from "../utils"
import { useContext, useEffect, useState } from "react"
import { secureAPICall } from "../utils/sessionUtils"
import { BACKEND_URI } from "../entries"
import { ContentContext } from "../contexts/ContentContext"



export const ChangelogComponent = () => {
    const { t } = useTranslation('dashboard')
    const { openErrorModal } = useContext(ContentContext)
    const [changelogs, setChangelogs] = useState([])

    const requestChangelogs = async ({verbose = false}) => {
        return secureAPICall({endpoint: BACKEND_URI + "/api/misc/fetch-changelogs", verbose: verbose})
    }

    useEffect(() => {
        requestChangelogs({})
        .then((data) => {
            setChangelogs(data.changelogs)
        })
        .catch((error) => {
            console.error(error.status, error.message)
            openErrorModal(error)
        })
    }, [])

    return (
        <div className="max-w-7xl flex flex-col items-center">
            <ul className="timeline timeline-snap-icon max-md:timeline-compact timeline-vertical max-w-4xl">
                {
                    changelogs.map((changelog, index) =>
                        <Changelog key={changelog.id} changelog={changelog} start={index % 2 == 0} />
                    )
                }
            </ul>
        </div>
    )
}


const Changelog = ({ changelog, start = true }) => {

    return (
        <li>
            <hr />
            <div className="timeline-middle">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="h-5 w-5">
                    <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                        clipRule="evenodd" />
                </svg>
            </div>
            <div className={`${start ? "timeline-start md:text-end" : "timeline-end"}  md:mb-10`}>
                <time className="font-mono italic">{typeof changelog.date === 'number' ? formatTimestamp(changelog.date * 1000) : changelog.date}</time>
                <div className="text-lg font-black">{changelog.title}</div>
                {changelog.message}
            </div>
            <hr />
        </li>

    )
}


export const AddChangelogComponent = ({callback}) => {
    const { openErrorModal } = useContext(ContentContext)
    const [date, setDate] = useState("")
    const [title, setTitle] = useState("")
    const [message, setMessage] = useState("")

    const requestAddChangelog = async ({date, title, message, verbose = false}) => {
        const formData = new FormData()
        formData.append("date", date)
        formData.append("title", title)
        formData.append("message", message)
        return secureAPICall({endpoint: BACKEND_URI + "/api/misc/add-new-changelog", body: formData, verbose: verbose})
    }




    const handleSendChangelog = () => {
        if (title !== "" && message !== "") {
            requestAddChangelog({date: date, title: title, message: message})
            .then(() => {
                callback()
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
        }
    }

    return (
        <div className="">
            <div className="flex flex-col gap-2 w-72">
                <label className="form-control">
                    <input
                        type="text"
                        placeholder='HH:MM DD.MM:YYYY or empty'
                        className="input input-bordered input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                        required={true}
                        value={date}
                        onChange={(e) => {
                            setDate(e.target.value);
                        }}
                    />
                </label>
                <label className="form-control">
                    <input
                        type="text"
                        placeholder='Title'
                        className="input input-bordered input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                        required={true}
                        value={title}
                        onChange={(e) => {
                            setTitle(e.target.value);
                        }}
                    />
                </label>
                <label className="form-control">
                    <textarea
                        placeholder='Message'
                        className="textarea textarea-bordered textarea-md w-full h-40 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                        required={true}
                        value={message}
                        onChange={(e) => {
                            setMessage(e.target.value);
                        }}
                    />
                </label>

                <div className="flex w-full justify-center">
                    <button className="btn btn-sm w-32 " onClick={handleSendChangelog}>Send</button>
                </div>
            </div>
        </div>
    )
}